import React from 'react';
import { ChevronUp, ChevronDown } from 'lucide-react';

interface SortableTableHeaderProps {
  field: string;
  label: string;
  currentSortField: string | null;
  sortDirection: 'asc' | 'desc';
  onSort: (field: string) => void;
  align?: 'left' | 'right';
}

export const SortableTableHeader: React.FC<SortableTableHeaderProps> = ({
  field,
  label,
  currentSortField,
  sortDirection,
  onSort,
  align = 'left'
}) => {
  const isActive = currentSortField === field;

  return (
    <th 
      className={`p-3 cursor-pointer select-none hover:bg-opacity-5 transition-colors ${align === 'right' ? 'text-right' : 'text-left'}`}
      style={{ 
        color: isActive ? 'var(--color-accent)' : 'var(--color-text-secondary)',
        fontWeight: isActive ? '600' : '500'
      }}
      onClick={() => onSort(field)}
    >
      <div className={`flex items-center gap-1 ${align === 'right' ? 'justify-end' : ''}`}>
        <span>{label}</span>
        <div className="flex flex-col">
          {isActive ? (
            sortDirection === 'asc' ? (
              <ChevronUp className="w-4 h-4" />
            ) : (
              <ChevronDown className="w-4 h-4" />
            )
          ) : (
            <div className="w-4 h-4 opacity-30">
              <ChevronUp className="w-3 h-3 -mb-1" />
              <ChevronDown className="w-3 h-3" />
            </div>
          )}
        </div>
      </div>
    </th>
  );
};

